export default "__VITE_ASSET__Bek5IxYz__"